import { RootState } from '../index';

const getStaff = (state: RootState) => state.posReducer.staff;

const getIsDisplaySuccessAnim = (state: RootState) => state.posReducer.isDisplaySuccessAnimation;

export {
  getStaff,
  getIsDisplaySuccessAnim,
};
